import React from 'react';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { User } from '../../../global';
import { designUrlForContestName, designUrlForGallery, designUrlForGalleryFromNames } from '../../../helpers/navigationUtils';
import { useNavigate } from 'react-router-dom';

interface DesignPagerProps {
  prevName: string | undefined;
  nextName: string | undefined;
  userNameForURL?: string;
  contestNameForURL?: string;
}

export const DesignPager: React.FC<DesignPagerProps> = ({ prevName, nextName, userNameForURL, contestNameForURL }) => {
  const redirect = useNavigate();

  const goToDesignDetails = async (name: string | undefined) => {
    if (!name) return;
    console.log('GO TO DESIGN DETAILS');
    console.log(userNameForURL);
    console.log(contestNameForURL);
    if (userNameForURL) {
      redirect(designUrlForGalleryFromNames(userNameForURL, name));
    } else if (contestNameForURL) {
      redirect(designUrlForContestName(contestNameForURL, name));
    }
  };

  return (
    <div className={` py-2 px-2 `}>
      <button className={`btn-icon ${prevName ? '' : 'disabled'}`} onClick={() => goToDesignDetails(prevName)}>
        <FontAwesomeIcon icon={faAngleLeft as IconProp} className={`btn-icon ${prevName ? 'active' : 'disabled'}`} /> &nbsp; Prev design
      </button>
      &nbsp;&nbsp;
      <button className={`btn-icon ${nextName ? '' : 'disabled'}`} onClick={() => goToDesignDetails(nextName)}>
        Next design &nbsp;
        <FontAwesomeIcon icon={faAngleRight as IconProp} className={`btn-icon ${nextName ? 'active' : 'disabled'}`} />
      </button>
    </div>
  );
};
